(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["idolnest-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', event => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-in-artist-category-input]')) return;
    const section = event.target.closest('[data-in-shared-artists]');
    const track = section?.querySelector('.artist-track');
    if (track) track.scrollLeft = 0;
  });
  document.addEventListener('shopify:block:select', event => {
    if (!(event.target instanceof Element)) return;
    const card = event.target.closest('[data-in-shared-artist]');
    const section = card?.closest('[data-in-shared-artists]');
    if (!section) return;
    const choice = Array.from(section.querySelectorAll('[data-in-artist-category-input]')).find(input => input.value === card.dataset.inArtistCategory);
    if (choice) choice.checked = true;
    requestAnimationFrame(() => card.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'}));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["idolnest-promo-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.IdolNestPromoCarousel) {
      window.IdolNestPromoCarousel.init(document);
      return;
    }
    const instances = new Map();
    const rootsIn = scope => {
      const roots = Array.from(scope.querySelectorAll('[data-in-promo]'));
      if (scope.matches && scope.matches('[data-in-promo]')) roots.unshift(scope);
      return roots;
    };
    const init = scope => {
      rootsIn(scope).forEach(root => {
        if (instances.has(root)) return;
        const slides = Array.from(root.querySelectorAll('[data-in-promo-slide]'));
        if (!slides.length) return;
        const controller = new AbortController();
        const { signal } = controller;
        const track = root.querySelector('[data-in-promo-track]');
        const originalTabIndex = track.getAttribute('tabindex');
        const controls = root.querySelector('[data-in-promo-controls]');
        const dots = Array.from(root.querySelectorAll('[data-in-promo-dot]'));
        const nativeMode = !dots.length && !root.querySelector('[data-in-promo-previous]') && !root.querySelector('[data-in-promo-next]');
        const playback = root.querySelector('[data-in-promo-playback]');
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const interval = Math.max(4000, Number(root.dataset.interval || 6) * 1000);
        let index = 0;
        let timer;
        let hovering = false;
        let focused = false;
        let visible = true;
        let userPaused = motion.matches;
        let sectionSelected = false;
        let selectedBlock = null;
        let pointer = null;
        let lastSwipe = -Infinity;
        const stop = () => {
          window.clearTimeout(timer);
          timer = null;
        };
        const syncPlayback = () => {
          if (!playback) return;
          playback.hidden = motion.matches;
          playback.setAttribute('aria-pressed', String(userPaused || motion.matches));
          playback.setAttribute('aria-label', userPaused || motion.matches ? root.dataset.playLabel : root.dataset.pauseLabel);
        };
        const schedule = () => {
          stop();
          if (slides.length < 2 || root.dataset.autoplay !== 'true' || userPaused || motion.matches || hovering || focused || !visible || document.hidden || sectionSelected || selectedBlock) return;
          timer = window.setTimeout(() => show(index + 1), interval);
        };
        const show = next => {
          index = (next + slides.length) % slides.length;
          slides.forEach((slide, slideIndex) => {
            slide.hidden = !nativeMode && slideIndex !== index;
            if (nativeMode) slide.removeAttribute('aria-hidden');
            else slide.setAttribute('aria-hidden', String(slideIndex !== index));
          });
          if (nativeMode) track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: motion.matches ? 'auto' : 'smooth' });
          dots.forEach((dot, dotIndex) => {
            if (dotIndex === index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          root.dataset.activeSlide = String(index);
          schedule();
        };
        root.classList.add(nativeMode ? 'is-native' : 'is-enhanced');
        if (nativeMode) track.setAttribute('tabindex', '0');
        else track.removeAttribute('tabindex');
        if (controls) controls.hidden = false;
        if (nativeMode) track.addEventListener('scroll', () => {
          index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
          root.dataset.activeSlide = String(index);
          schedule();
        }, { signal, passive: true });
        root.addEventListener('click', event => {
          if (performance.now() - lastSwipe < 400) {
            event.preventDefault();
            return;
          }
          const button = event.target.closest('button');
          if (!button || !root.contains(button)) return;
          if (button.hasAttribute('data-in-promo-dot')) show(Number(button.dataset.inPromoDot));
          if (button.hasAttribute('data-in-promo-previous')) show(index - 1);
          if (button.hasAttribute('data-in-promo-next')) show(index + 1);
          if (button === playback) {
            if (motion.matches) userPaused = true;
            else userPaused = !userPaused;
            syncPlayback();
            schedule();
          }
        }, { signal });
        root.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          hovering = true;
          schedule();
        }, { signal });
        root.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          hovering = false;
          schedule();
        }, { signal });
        root.addEventListener('pointerdown', event => {
          if (nativeMode || event.pointerType === 'mouse') return;
          pointer = { x: event.clientX, y: event.clientY };
        }, { signal, passive: true });
        root.addEventListener('pointerup', event => {
          if (!pointer) return;
          const distanceX = event.clientX - pointer.x;
          const distanceY = event.clientY - pointer.y;
          pointer = null;
          if (Math.abs(distanceX) > 50 && Math.abs(distanceY) < Math.abs(distanceX) / 2) {
            lastSwipe = performance.now();
            show(index + (distanceX < 0 ? 1 : -1));
          }
        }, { signal, passive: true });
        root.addEventListener('pointercancel', () => { pointer = null; }, { signal });
        root.addEventListener('focusin', () => { focused = true; schedule(); }, { signal });
        root.addEventListener('focusout', event => {
          focused = root.contains(event.relatedTarget);
          schedule();
        }, { signal });
        document.addEventListener('visibilitychange', schedule, { signal });
        motion.addEventListener('change', () => { syncPlayback(); schedule(); }, { signal });
        const observer = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          schedule();
        }, { threshold: 0.1 });
        observer.observe(root);
        const instance = {
          selectBlock: id => {
            selectedBlock = id;
            const next = slides.findIndex(slide => slide.dataset.promoBlockId === id);
            if (next >= 0) show(next);
            else schedule();
          },
          deselectBlock: () => { selectedBlock = null; schedule(); },
          selectSection: value => { sectionSelected = value; schedule(); },
          cleanup: () => {
            stop();
            controller.abort();
            observer.disconnect();
            root.classList.remove('is-enhanced', 'is-native');
            if (originalTabIndex === null) track.removeAttribute('tabindex');
            else track.setAttribute('tabindex', originalTabIndex);
            slides.forEach(slide => { slide.hidden = false; slide.removeAttribute('aria-hidden'); });
            if (controls) controls.hidden = true;
            instances.delete(root);
          }
        };
        instances.set(root, instance);
        syncPlayback();
        show(0);
      });
    };
    const eventInstance = event => {
      const root = event.target.closest('[data-in-promo]') || event.target.querySelector('[data-in-promo]');
      return root && instances.get(root);
    };
    document.addEventListener('shopify:section:load', event => init(event.target));
    document.addEventListener('shopify:section:unload', event => rootsIn(event.target).forEach(root => instances.get(root)?.cleanup()));
    document.addEventListener('shopify:block:select', event => eventInstance(event)?.selectBlock(event.detail.blockId));
    document.addEventListener('shopify:block:deselect', event => eventInstance(event)?.deselectBlock());
    document.addEventListener('shopify:section:select', event => eventInstance(event)?.selectSection(true));
    document.addEventListener('shopify:section:deselect', event => eventInstance(event)?.selectSection(false));
    window.IdolNestPromoCarousel = { init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
  })();

  } catch(e) { console.error(e); }
})();
})();
